import { errorToast, successToast } from "./toast";
import { eventBus } from "./eventBus";
import { PageStatus } from "@/stores/provider";

// 获取请求参数
export const getUrlQuery = (): URLSearchParams => {
  const query = new URLSearchParams(window.location.search);
  return query;
};

// 日期格式化
export const formatDate = (date: Date = new Date(), format = 'YYYY-MM-DD HH:mm:ss') => {
  const year = String(date.getFullYear());
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);
};
export const getWeekday = () => {
  const currentDate = new Date();
  const weekdayIndex = currentDate.getDay();
  const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  const weekday = weekdays[weekdayIndex];
  return weekday;
};

export const numberToChinese = (v: number) => {
  const unit = ['', '十', '百', '千'];
  const numChars = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  if (v < 10) {
    return numChars[v];
  }
  if (v < 100) {
    const ten = Math.floor(v / 10);
    const one = v % 10;
    return (ten > 1 ? numChars[ten] : '') + unit[1] + (one > 0 ? numChars[one] : '');
  }
  if (v < 1000) {
    const hundred = Math.floor(v / 100);
    const ten = Math.floor((v % 100) / 10);
    const one = v % 10;
    return (hundred > 0 ? numChars[hundred] : '') + unit[2] + (ten > 0 ? (ten > 1 ? numChars[ten] : '') + unit[1] : '') + (one > 0 ? numChars[one] : '');
  }

}

export const isSafari = () => {
  const userAgent = navigator.userAgent;
  return /^((?!chrome|android).)*safari/i.test(userAgent);
}

export const isDesktop = (): boolean => !navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile|Windows Phone|BlackBerry)/i);

export const copyToClipboard = async (text: string | Promise<string>, opts: boolean | string = true): Promise<void> => {
  const showTip = !!opts;
  const tipText = (typeof opts === 'string' && opts) || '文本复制成功';

  let copyText = '';
  if (text instanceof Promise) {
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/plain': text.then((content) => {
            if (!content) {
              return '';
            }
            if (showTip) {
              successToast(tipText);
            }
            return new Blob([content], { type: 'text/plain' });
          }),
        }),
      ]);

      return;
    } catch (e) {
      console.error('❗ ~ file:index.ts line:236 ----- e', e);
    }

    copyText = await text;
  } else {
    copyText = text;
  }

  try {
    await navigator.clipboard.writeText(copyText);
    if (showTip) {
      successToast(tipText);
    }
    return;
  } catch (e) {
    console.error('❗ ~ file:index.ts line:247 ----- e', e);
  }

  const textarea = document.createElement('textarea');
  document.body.appendChild(textarea);
  textarea.style.position = 'fixed';
  textarea.style.clip = 'rect(0 0 0 0)';
  textarea.style.top = '10px';
  textarea.value = copyText;
  textarea.select();
  document.execCommand('copy', true);
  document.body.removeChild(textarea);

  if (showTip) {
    successToast(tipText);
  }
};

export const clearLoginMes = (v?: string) => {
  eventBus.emit('eventBusDispatch', {
    pageStatus: PageStatus.NOLOGIN,
    agreedCheck: false,
  });
  sessionStorage.removeItem('videoAudit-token');
  sessionStorage.removeItem('videoAudit-pageStatus');
  sessionStorage.removeItem('videoAudit-agreedCheck');
  sessionStorage.removeItem('videoAudit-temporaryLogin');
  errorToast(v || '登录过期');
};